import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que pone la primera letra del string en mayuscula
 */
@Pipe({
    name: 'firstuppercase',
    standalone: false
})
export class FirstUppercasePipe implements PipeTransform {
  constructor() { }

  /**
   * Transforma el texto
   *
   * @param value valor a cambiar
   * @returns valor con la primera letra en mayuscula
   */
  transform(value: string) {
    return value.substring(0, 1).toUpperCase() + value.substring(1);
  }
}
